angular.module('beneple.global')
  .constant('additional_config', {
    apiUrl: "https://app2.beneple.com"
  });

// angular.module('beneple.global')
//   .constant('additional_config', {
//     apiUrl: "https://node-staging.beneple.com"
//   });

// angular.module('beneple.global')
//   .constant('additional_config', {
//   apiUrl: 'http://localhost:3000'
// });





// WEBPACK FOOTER //
// ./frontend/scripts/enviroments/enviroments.dev.ts